import { render } from "./PublicBookingView.vue?vue&type=template&id=35e353ee&scoped=true&ts=true"
import script from "./PublicBookingView.vue?vue&type=script&lang=ts"
export * from "./PublicBookingView.vue?vue&type=script&lang=ts"

import "./PublicBookingView.vue?vue&type=style&index=0&id=35e353ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e353ee"]])

export default __exports__